import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { cerrarSesion } from '../../helpers/cerrarSesion'
import { useAuth } from '../../hooks/useAuth'
import { ModalContenidoTerminos } from './ModalContenidoTerminos'
import styles from './ModalTerminos.module.css'

export const ModalTerminos = ({
  show,
  esAdmin,
  esPrimerAcceso,
  debeAceptarTerminos,
  onAceptar,
  onContinuar
}) => {
  const [mostrarContenido, setMostrarContenido] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleRevokeToken = () => {
    cerrarSesion(logout)
  }

  const handleAceptar = async () => {
    setEnviando(true)
    try {
      await onAceptar()
      setMostrarContenido(false)
      navigate('/Soporte')
    } finally {
      setEnviando(false)
    }
  }

  const handleContinuar = () => {
    onContinuar()
    navigate('/Soporte')
  }

  return (
    <>
      <Modal
        show={show && !mostrarContenido}
        centered
        backdrop="static"
        keyboard={false}
        aria-labelledby="modal-terminos-titulo"
        className={styles.dialogAviso}
      >
        <Modal.Header>
          <Modal.Title id="modal-terminos-titulo">
            {esPrimerAcceso ? '¡Bienvenido a e-BuyMarket!' : 'Términos y Condiciones'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {debeAceptarTerminos ? (
            esAdmin ? (
              <p className="mb-0">
                Para comenzar a usar <strong>e-BuyMarket</strong> es necesario que leas y aceptes
                nuestros Términos y Condiciones de uso.
              </p>
            ) : (
              <p className="mb-0">
                Tu empresa debe aceptar los Términos y Condiciones de e-BuyMarket para poder operar.
                Comunicate con el administrador de tu empresa.
              </p>
            )
          ) : esAdmin ? (
            <p className="mb-0">¡Esperamos que tengas una excelente experiencia!</p>
          ) : (
            <p className="mb-0">Accedé a la página de soporte para ver los instructivos.</p>
          )}
        </Modal.Body>

        <Modal.Footer className={styles.footer}>
          {!debeAceptarTerminos ? (
            <Button variant="primary" onClick={handleContinuar}>
              Continuar
            </Button>
          ) : esAdmin ? (
            <>
              <Button variant="primary" onClick={() => setMostrarContenido(true)}>
                Ver Términos y Condiciones
              </Button>
              <Button variant="danger" onClick={handleRevokeToken}>
                Salir
              </Button>
            </>
          ) : (
            <Button variant="danger" onClick={handleRevokeToken}>
              <i className="fa fa-sign-out" aria-hidden="true" /> Salir
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ModalContenidoTerminos
        show={mostrarContenido}
        onCerrar={() => setMostrarContenido(false)}
        onAceptar={handleAceptar}
        onRechazar={handleRevokeToken}
        enviando={enviando}
      />
    </>
  )
}

ModalTerminos.propTypes = {
  show: PropTypes.bool.isRequired,
  esAdmin: PropTypes.bool.isRequired,
  esPrimerAcceso: PropTypes.bool,
  debeAceptarTerminos: PropTypes.bool.isRequired,
  onAceptar: PropTypes.func.isRequired,
  onContinuar: PropTypes.func
}
